import styled from 'styled-components';

import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';

export const StyledTooltipContainer = styled(TooltipContainer)`
  border: none;
  background: none;
  box-shadow: none;
  position: relative;
  max-width: 100%;
  padding: 0px 12px;
`;

export const IconContainer = styled.div<{ $top: number; $right: number }>`
  position: absolute;
  cursor: pointer;
  top: ${({ $top }) => $top}px;
  right: ${({ $right }) => $right}px;

  &:hover {
    transform: scale(1.25);
  }
`;
